import React from 'react';
import TumbNail from '../event/thumb_nail';

const SearchEventBoxVertical = ({
  eventItem,
  currentUser,
  hashedCompanyId = null,
}) => {
  const adParam = eventItem.hashed_event_pr_allocation_id
    ? `event_pr_allocation=${eventItem.hashed_event_pr_allocation_id}`
    : eventItem.hashed_circles_ad_id
      ? `circles_ad=${eventItem.hashed_circles_ad_id}`
      : null;
  let eventUrl = eventItem.ad_type && adParam
    ? '/circle/' +
      eventItem.circle.id +
      '/events/' +
      eventItem.id +
      `?${adParam}`
    : '/circle/' + eventItem.circle.id + '/events/' + eventItem.id;
  eventUrl = hashedCompanyId
    ? '/community/' + hashedCompanyId + eventUrl
    : eventUrl;

  return (
    <React.Fragment>
      <div
        key={eventItem.id}
        className="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-3 p-1 mb-3"
        data-event-id={eventItem.id}
      >
        <div className="container h-100 event-flame">
          <a href={eventUrl} className="hov--default">
            <div className="adjust-box adjust-box-16x9 row">
              <TumbNail eventItem={eventItem}/>
              {eventItem.is_full ? (
                <img
                  data-src="/assets2019/img/event/img-event_sold_out.svg"
                  style={{ marginLeft: '0px', height: '60%', zIndex: 10 }}
                  className="lazyload position-absolute"
                />
              ) : eventItem.is_application_ended ? (
                <img
                  data-src="/assets2019/img/event/img-event_end.svg"
                  style={{ marginLeft: '0px', height: '60%', zIndex: 10 }}
                  className="lazyload position-absolute"
                />
              ) : (
                ''
              )}
              {currentUser && currentUser.id ? (
                <button
                  className="btn-follow event-list-follow position-absolute"
                  style={{
                    height: '36px',
                    width: '36px',
                    padding: '0',
                    background: '0',
                    border: 'none',
                  }}
                  data-event_id={eventItem.id}
                  data-circle_id={eventItem.circle.id}
                  data-followed="false"
                >
                  <img src="/assets2019/img/favorite_border_black_24dp.svg" />
                </button>
              ) : (
                ''
              )}

            </div>

            <div className="container p-0">
              <div className="row flex-row">
                <div className="pt-2 col-4 col-sm-4 pd-0 pb-1 d-flex flex-column align-items-center">
                  <div className="event-time-field">
                    <div className="event-month-text text-center text-fw-bold w-100">
                      {eventItem.event_month_only}月
                    </div>
                    <div className="event-date-text align-items-baseline" style={{marginTop: '-5px'}}>
                      {eventItem.event_date_only}
                      <span className="event-day-text">({eventItem.event_date_weekday_kanji})</span>
                    </div>
                  </div>
                  <div className="event-time-text text-center w-100 pt-2"> 
                    {eventItem.event_time_only}
                  </div>
                  <div className="ml-1">
                    {!eventItem.is_online ? (
                      <p className="mb-0 pt-1 event-place-text text-center w-100">
                        <span>
                          {eventItem.countries_pref
                            ? eventItem.countries_pref.name == '北海道'
                              ? eventItem.countries_pref.name
                              : eventItem.countries_pref.name.slice(0, -1)
                            : '全国'}
                        </span>
                      </p>
                    ) : (
                      <p className="mb-0 pt-1 event-online-text text-center w-100">
                        オンライン
                      </p>
                    )}
                  </div>
                </div>

                <div className="col-8 col-sm-8 pb-1 pd-0">
                  <div className="pt-1 px-1">

                    <div className="px-1 event-title-field">
                      <p
                        className={`mt-1 mb-3 line-3 event-title-text ${
                          eventItem.circle.is_company_owned
                            ? 'icon-tunagate_official_sm_before'
                            : ''
                        }`}
                      >
                        {eventItem.title}
                      </p>
                    </div>

                    <div className="w-100 event-icon-field">
                      <ul className="d-flex align-items-end list-unstyled overflow-x-hidden-list mt-1 mb-0 w-100">
                        {eventItem.valid_events_plans_users &&
                          eventItem.valid_events_plans_users
                            .slice(0, 10)
                            .map(function (events_plans_user) {
                              return (
                                events_plans_user.user && (
                                  <li key={events_plans_user.id}>
                                    <img
                                      className="member-icon-xxs lazyloaded"
                                      src={`${events_plans_user.user.avatar_thumb}`}
                                    />
                                  </li>
                                )
                              );
                            })}
                        {eventItem.valid_events_follows &&
                          eventItem.valid_events_follows
                            .slice(0, 10 - eventItem.num_of_participants)
                            .map(function (events_follow) {
                              return (
                                <li key={events_follow.id}>
                                  <img
                                    className="member-icon-xxs lazyloaded"
                                    src={`${
                                      events_follow.user &&
                                      events_follow.user.avatar_thumb
                                    }`}
                                  />
                                </li>
                              );
                            })}
                      </ul>

                      <div className="event-campaign-field">
                        {eventItem.max_point > 0 && (
                          <p className="text-black mt-1 mb-1 event-campaign-text">
                            最大
                            <span className="text-orange event-campaign-text text-fw-bold">
                              {eventItem.max_point}pt
                            </span>
                            もらえる！
                          </p>
                        )}
                      </div>

                      <div className="event-ciecle-field">
                        
                        {eventItem.ad_type ? (
                          <p className="mb-1 line-1 event-circle-text text-gray">
                            {eventItem.ad_type && '[PR] '}
                            {eventItem.circle.name}
                          </p>
                        ) : (
                          <p className="mb-1 line-1 event-circle-text text-gray">
                            {eventItem.circle.name}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SearchEventBoxVertical;